import { DropdownOption } from '@hawkins/components';
import { FormikProps } from 'formik';
import { FormState, SqueezedMode } from '../../types';
import { shouldConfirmLensSqueezeChange } from './shouldConfirmLensSqueezeChange';

export const LENS_SQUEEZE_CHANGE_CONFIRM_TITLE = 'Change lens squeeze factor?';

export const LENS_SQUEEZE_CHANGE_CONFIRM_MESSAGE =
  'Changing the lens squeeze factor will clear your custom framing decision values. Do you want to continue?';

type ApplyLensSqueezeSelectionArgs = {
  selected: DropdownOption<number>;
  form: Pick<FormikProps<FormState>, 'setFieldValue'>;
  clearCustomFramingFirst?: boolean;
};

/**
 * Updates lens squeeze and related form fields. Optionally clears custom framing first.
 */
export function applyLensSqueezeSelection({
  selected,
  form,
  clearCustomFramingFirst = false,
}: ApplyLensSqueezeSelectionArgs): void {
  if (clearCustomFramingFirst) {
    form.setFieldValue('customFramingDecisionWidth', null);
    form.setFieldValue('customFramingDecisionHeight', null);
  }

  form.setFieldValue('lensSqueezeFactor', selected);
  if (selected.value === 1) {
    form.setFieldValue('squeezedMode', SqueezedMode.Squeezed);
  }
}

/**
 * Whether the user must confirm in a modal before applying this lens squeeze change
 */
export function shouldPromptForLensSqueezeChange(
  selected: DropdownOption<number>,
  values: FormState
): boolean {
  return shouldConfirmLensSqueezeChange({
    customFramingDecisionWidth: values.customFramingDecisionWidth,
    customFramingDecisionHeight: values.customFramingDecisionHeight,
    lockAspectRatio: values.lockAspectRatio,
    currentLensSqueezeValue: values.lensSqueezeFactor.value,
    newLensSqueezeValue: selected.value,
  });
}
